import script from "./DailyRewardsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyRewardsModal.vue?vue&type=script&setup=true&lang=js"

import "./DailyRewardsModal.vue?vue&type=style&index=0&id=947dde94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-947dde94"]])

export default __exports__